module.exports = __webpack_public_path__ + "img/ic_rotate.a7cce70b.svg";